import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Firm from '../../entities/firm';

/*
 * Delete/nullify anywhere this firm is used in other entities
 *
 * @param {Firm} firm
 */
export function deleteFirm(firm: Firm, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = firm.id;
    }

    /* Remove the actual firm */
    firm.status = 'D';
    firm.addedOn = newHRTimestamp();
    firm.addedBy = getCurrentUserId();
    firm.importSource = targetImportSource;
    firm.importId = mergeId;
    store.dispatch(Actions.FirmActions.removeFirmQueue(firm));
    
}